// src/components/common/InfoTooltip.jsx
import React from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import PropTypes from "prop-types";

const InfoTooltip = ({
  content,
  size = "16px",
  color = "#6B7280",
  marginLeft = "4px",
  style = {},
  className = "",
}) => {
  return (
    <AiOutlineInfoCircle
      title={content}
      className={className}
      style={{
        marginLeft,
        cursor: "help",
        color,
        fontSize: size,
        verticalAlign: "middle",
        display: "inline-flex",
        alignItems: "center",
        transition: "color 0.2s ease",
        ...style,
      }}
    />
  );
};

InfoTooltip.propTypes = {
  content: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  marginLeft: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default InfoTooltip;
